import { render, staticRenderFns } from "./VehicleExamination.vue?vue&type=template&id=50e583a7&"
import script from "./VehicleExamination.vue?vue&type=script&lang=js&"
export * from "./VehicleExamination.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports